import {
  logger, enableLog, disableLog, setLogContext,
} from '@ahaslides-product/frontend-toolkit'
import Config from '@/config'

const _getters = {
  logConfig: (_, __, ___, rootGetters) => {
    const variant = rootGetters['featureToggles/getVariant']('AHA-35479-setup-logging-lib')
    if (variant?.payload?.type === 'json') {
      return JSON.parse(variant.payload.value)
    }
    return undefined
  },
  canTrackSlideIdForPostReqs: (_, __, ___, rootGetters) => {
    return rootGetters['featureToggles/isFeatureEnabled']('AHA-40581-track-answer-slideid')
  },
}

const plugin =
  (store) => {
    store.subscribe((mutation) => {
      if (mutation.type === 'featureToggles/setFeatures') {
        if (!store.getters['featureToggles/canUseLogFile']) {
          disableLog()
        } else {
          // enableLog overwrites env/remoteLog* on every call, so the
          // environment-derived inputs must be passed alongside the
          // feature-flag config each time.
          enableLog({
            ...store.getters['logger/logConfig'],
            env: Config.env,
            remoteLogUrl: Config.remoteLogUrl,
            remoteLogAuth: Config.remoteLogAuth,
          })
        }
      }
    })

    const actionLog = logger.extend('vuex:action')

    // Set of vuex actions to ignore in logging
    const IGNORED_ACTIONS = new Set([
      'systemConnection/setEmqxConnection',
      'systemConnection/setSocketConnection',
      'websocket/newMessage',
    ])

    const SLIDE_ACTIONS = new Set([
      'setSlide',
      'updateSlide',
      'nextback/changeSlideAction',
    ])

    // Log actions
    store.subscribeAction({
      after: (action) => {
        // Skip logging for ignored actions
        if (IGNORED_ACTIONS.has(action.type)) {
          return
        }
        const slide = SLIDE_ACTIONS.has(action.type) ? action.payload : action.payload?.slide
        if (slide?.id != null) {
          actionLog(action.type, null, { slideId: slide.id, slideVersion: slide.version })
        } else if (typeof action.payload === 'number') {
          actionLog(action.type, action.payload)
        } else {
          actionLog(action.type)
        }
        if (action.type === 'setAudienceIdAction') {
          setLogContext({
            audienceId: action.payload,
          })
        } else if (action.type === 'setPresentationAction') {
          setLogContext({
            presentationId: action.payload.id,
          })
        } else if (action.type === 'setCurrentUserAction') {
          setLogContext({
            userId: action.payload.id,
          })
        }
      },
    })
  }

export default {
  namespaced: true,
  getters: _getters,
  plugin,
}
